import React from "react";

import styles from "./summary.module.css";
import pen from "images/plus.svg";

import constants from "constants/fi.json";

interface Props {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  isAdding: boolean;
}

const Add = ({ onClick, isAdding }: Props) => {
  const classes = [styles.edit];

  if (isAdding) {
    classes.push(styles.isEditing);
  }

  return (
    <div className={classes.join(" ")} onClick={onClick}>
      <img src={pen} alt="" className={styles.pen} />
      <span>{constants.add}</span>
    </div>
  );
};

export default Add;
